import { fetchMedia } from '@/shared/lib';
import { DSCVR_STATIC_ASSETS_CDN_URL } from '@/common';

export const solanaLogos = [
  fetchMedia(`${DSCVR_STATIC_ASSETS_CDN_URL}/logos/colored-solflare.png`),
  fetchMedia(`${DSCVR_STATIC_ASSETS_CDN_URL}/logos/colored-phantom.png`),
];
